const homeContent = require("static/content/it/home.json");
const productsContent = require("static/content/it/products.json");
const resultsContent = require("static/content/it/results.json");

export default {
  home: homeContent,
  products: productsContent,
  results: resultsContent,
};
